var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  className: "user-icon_svg__sc-tag3-icon-svg",
  style: {
    height: "inherit",
    width: "inherit",
    fill: "#e8ad44"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon - User",
  d: "M19 21H5a2 2 0 0 1-2-2l2-3s.9-2 2-2h2.2a4.789 4.789 0 0 0 2.8 1 4.791 4.791 0 0 0 2.8-1H17c1.1 0 2 2 2 2l2 3a2 2 0 0 1-2 2Zm-7-8c-2.209 0-4-2.532-4-4.833A4.085 4.085 0 0 1 12 4a4.086 4.086 0 0 1 4 4.167c0 2.3-1.794 4.833-4 4.833Z",
  className: "user-icon_svg__sc-tag3-icon-svg"
})));
export default SvgUserIcon;